import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Button from "../../../shared-components/Form/Button";
import toast from "react-hot-toast";
import { Formik } from "formik";
import OnboardingLayout from "../../../shared-components/Layout/OnboardingLayout";
import { useDispatch } from "react-redux";
import { userDetailsAction } from "../../../features/auth/reducer/userReducer";
import SEO from "../../../shared-components/Seo/Seo";
import authService from "../../../features/auth/authAction";
import { trackEvent } from "../../../analytics";
import { identifyDevice } from "../../../utils/funnel";
import waving from "../../../assets/images/waving.svg";
import OtpInput from "../../../shared-components/Form/NumericOtpInput";
import HervestLoading from "../../../shared-components/Layout/HervestLoading";
import { loginAction } from "../../../features/auth/reducer/loginReducer";
import userServices from "../../../features/user/userAction";

const LoginPin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const firstName = localStorage.getItem("firstName");
  const [error, setError] = useState(false);
  const [pin, setPin] = useState(false);

  const handleSubmit = async (setSubmitting) => {
    if (pin.length < 6) {
      setSubmitting(false);
      return setError("Invalid Passcode");
    }

    setError("");
    const res = await authService.loginWithPin({
      email: localStorage.getItem("email"),
      pin: pin,
    });

    setSubmitting(false);

    if (res) {
      toast.success(`Welcome Back`);
      localStorage.setItem("token", res.data.token);
      identifyDevice();
      trackEvent("login_completed", { method: "email" });
      dispatch(userDetailsAction());
      dispatch(
        loginAction({
          user: res?.data?.user,
          token: res?.data?.token,
          hasCard: res.data.hasCard,
          hasCover: res?.data?.hasCover,
          hasBank: res?.data?.hasBank,
        })
      );
      if (res?.data?.user?.last_name) {
        localStorage.setItem("firstName", res.data.user.last_name);
      }
      localStorage.setItem("token", res.data.token);
      const hashUserRes = await userServices.hashUser();

      if (hashUserRes) {
        localStorage.setItem("hashSignature", hashUserRes?.data?.signature);
      }

      //UPDATE DEVICE NOTIFICATION TOKEN IF ALLOWED
      const notificationToken = localStorage.getItem("notificationToken");
      if (notificationToken) {
        authService.updateNotificationToken({
          token: notificationToken,
        });
      }

      dispatch(userDetailsAction()).then(() => {
        const loginDetails = res.data.user;
        navigate("/dashboard", { state: { loginDetails } });
      });
      navigate("/dashboard");
    }
  };

  return (
    <OnboardingLayout>
      <SEO
        title="Login pIN | HerVest"
        description="Login to your Hervest account"
      />
      <div>
        <h1 className="md:text-[32px] text-[28px] font-[700px] leading-10 text-[#5B2E4F] mb-8 text-center">
          <div className="flex text-3xl ">
            <span>Welcome Back! {firstName}</span>
            <img loading="lazy" src={waving} alt="hello" />
          </div>
        </h1>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          //   validationSchema={Yup.object({})}
          onSubmit={(values, { setSubmitting }) => {
            handleSubmit(setSubmitting);
          }}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit}>
              {props.isSubmitting && <HervestLoading />}

              <div className="flex flex-col justify-center items-center">
                <label>
                  <p className="font-[500px] leading-5 mb-5">
                    Enter your 6 digits passcode to continue
                  </p>
                </label>
                <OtpInput
                  value={pin}
                  onChange={(value) => {
                    setPin(value);
                    setError("");
                  }}
                  numInputs={6}
                  renderInput={(props) => <input {...props} type="password" />}
                  inputStyle={{
                    width: "50px",
                    height: "50px",
                    fontSize: "20px",
                    borderRadius: "10px",
                    border: `1px solid  ${error ? "#FF0000" : "#540A45"}`,
                    textAlign: "center",
                    marginRight: "3px",
                  }}
                />
              </div>

              <div className="my-10">
                <Button
                  type="submit"
                  //   isLoading={props.isSubmitting}
                  //   isdisabled={props.isSubmitting}
                  text="PROCEED"
                  onChange={handleSubmit}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </OnboardingLayout>
  );
};

export default LoginPin;
